const T = require('prop-types');
const { canViewGroup } = require('utils/groups');

const internals = {};

internals.groupWithId = (props, propName, componentName) => {

    const value = props[propName];

    if (!value?.id) {
        return new Error(`${componentName} is waiting for ${propName}`);
    }

    return null;
};

exports.hasAnnouncementChatDependencies = ({
    announcementConversation,
    classId,
    currentUser,
    group,
    rolePermissions,
    rolesInteractions,
    users
}) => !!announcementConversation
    && !!classId
    && !!currentUser
    && !!group?.id
    && !!rolePermissions
    && Array.isArray(rolesInteractions)
    && Array.isArray(users);

exports.canLoadAnnouncementChat = ({
    classId,
    group,
    rolePermissions,
    userIsInClass
}) => !!classId
    && !!group?.isAnnouncement
    && canViewGroup({
        group,
        rolePermissions,
        userIsInGroup: userIsInClass
    });

exports.dependencyPropTypes = {
    announcementConversation: T.object.isRequired,
    classId: T.string.isRequired,
    onRequestMessages: T.func.isRequired,
    currentUser: T.object.isRequired,
    group: internals.groupWithId,
    rolePermissions: T.object.isRequired,
    rolesInteractions: T.array.isRequired,
    users: T.array.isRequired
};

if (process.env.NODE_ENV === 'test') {
    exports._internals = internals;
}
